var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full justify-end px-4 pt-4 hlg:pt-10 relative z-30"},[_c('button',{staticClass:"text-white",on:{"click":_vm.closeModal}},[_c('XIcon',{staticClass:"w-8 h-8"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }